import React, { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useIntl } from "gatsby-plugin-react-intl"

// Grabs a snippet from Contentful for easy string translation

const Snippet = ({ id, field, md, ...props }) => {
  const intl = useIntl()

  const data = useStaticQuery(graphql`
    query SnippetQuery {
      allContentfulSnippet {
        nodes {
          name
          header
          node_locale
          text {
            text
            childMarkdownRemark {
              html
            }
          }
          linkText
          linkUrl
        }
      }
    }
  `)

  // if (!id) {
  //   return "Please provide an id."
  // }

  // if (!field) {
  //   return "Please provide a field."
  // }

  const match = useMemo(() => {
    return data.allContentfulSnippet.nodes.find(
      (node) => node.name === id && node.node_locale === intl.locale
    )
  }, [data, id, intl.locale])

  let result =
    field === "text"
      ? md
        ? match?.text?.childMarkdownRemark?.html
        : match?.text?.text
      : match?.[field]
  let renderedResult = md ? (
    <span dangerouslySetInnerHTML={{ __html: result }} />
  ) : (
    result
  )

  if (!result) {
    if (process.env.NODE_ENV === "development") {
      return (
        <div
          style={{ backgroundColor: "red", color: "white", fontWeight: "bold" }}
        >
          MISSING "{id}" ({field})
        </div>
      )
    } else {
      throw new Error(`No snippet found for "${id}", field "${field}".`)
    }
  }

  return renderedResult
}

export default Snippet
